import { Component, OnInit } from '@angular/core';
import { LogoService } from '../../services/logo.service';
import { Router } from '@angular/router';
import { devTabOptions } from '../../configs/dev-tab-options.config';

@Component({
  selector: 'app-org-logo',
  templateUrl: './org-logo.component.html',
  styleUrls: ['./org-logo.component.scss'],
})
export class OrgLogoComponent  implements OnInit {

  constructor(private logoService:LogoService,private router:Router) { }
  orgLogo:string|undefined
  menuItems: { label: string, icon: string, route: string ,enabled:boolean}[] = devTabOptions;


  ngOnInit() {
    this.orgLogo=this.logoService.orgLogo
  }
  navigateTo(route: string): void {
    this.router.navigate([route],{ replaceUrl: true });
  }

}
